import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "is-flex is-justify-content-start",
  style: {"gap":"1em"}
}
const _hoisted_2 = { key: 0 }

import { useStore } from "vuex";
import { onMounted} from "vue";

interface SpecialtyData {
  specialty_id: number;
  name: string;
}

//Vue 3 version;

import { defineComponent, defineProps } from 'vue'
import { Notyf } from "notyf";

const notyf = new Notyf()

const __default__ = defineComponent({
  name: "SpecialtyTableRow"
})

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    specialtyData: {},
    getEditingMode: { type: Boolean }
  },
  emits: ["showSpecialtyData", "removeSpecialty"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

console.log('[Child] specialtyData received:', props.specialtyData);

//const props = defineProps(['specialtyData', 'parentShowSpecialtyData'])
const store = useStore()

/*
const remove = async (specialtyData: any, $t: any) => {
  if (confirm($t && $t('SpecialtyData.ConfirmDelete'))) {
    //TODO:Create notification to ask if it is really to delete
    try {
      await store.dispatch('deleteSpecialty', specialtyData)
      notyf.success($t('SpecialtyData.NotyfSpecialtyRemoved'))
    } catch (e) {
      notyf.error($t('SpecialtyData.NotyfErrorRemoveSpecialty'))
    }
  }
}*/

onMounted(() => {

})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("th", null, _toDisplayString(_ctx.specialtyData.specialty_id), 1),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.specialtyData.name), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "button is-success is-small",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('showSpecialtyData', _ctx.specialtyData)))
          }, _toDisplayString(_ctx.$t('General.Details')), 1)
        ]),
        (_ctx.getEditingMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("button", {
                class: "button is-danger is-small",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('removeSpecialty', _ctx.specialtyData)))
              }, _toDisplayString(_ctx.$t('General.Delete')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})